
import { MapTo } from '@adobe/aem-react-editable-components';
import QuizText, { QuizTextEditConfig } from './QuizText';

export default MapTo('cob-corp-acquisition/components/creditonebank/quiz-text')(QuizText, QuizTextEditConfig);
        